import LocationPinIcon from '@/assets/icon/gsf-pin_drop.svg'
const LocationPin = () => {
  return <LocationPinIcon />;
};
export default LocationPin;